type ScreenWakeLock = WakeLockSentinel;

let activeLock: ScreenWakeLock | null = null;

function wakeLockSupported(): boolean {
  return typeof navigator !== 'undefined' && 'wakeLock' in navigator;
}

async function releaseNavWakeLock(): Promise<void> {
  if (!activeLock) return;
  try {
    if (!activeLock.released) await activeLock.release();
  } catch {
    /* already released */
  }
  activeLock = null;
}

export async function setNavWakeLock(keepAwake: boolean): Promise<void> {
  if (!wakeLockSupported()) return;

  if (!keepAwake) {
    await releaseNavWakeLock();
    return;
  }

  if (document.visibilityState !== 'visible') return;
  if (activeLock && !activeLock.released) return;

  try {
    const sentinel = await navigator.wakeLock!.request('screen');
    activeLock = sentinel;
    sentinel.addEventListener('release', () => {
      if (activeLock === sentinel) activeLock = null;
    });
  } catch {
    /* permission denied, low battery, unsupported context */
  }
}

export function bindNavWakeLockVisibility(resync: () => void): void {
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') resync();
  });
}
